import { animate, type AnimationOptionsWithOverrides } from "motion"

const OPTS: AnimationOptionsWithOverrides = { duration: 0.28, easing: [0.4, 0, 0.2, 1] }

export const WizardStep = {
  _prevStep: 0,

  mounted(this: typeof WizardStep & { el: HTMLElement }) {
    this._prevStep = parseInt(this.el.dataset.step ?? "1", 10)
    animate(this.el, { opacity: [0, 1], x: [32, 0] }, OPTS)
  },

  updated(this: typeof WizardStep & { el: HTMLElement }) {
    const next = parseInt(this.el.dataset.step ?? "1", 10)
    if (next === this._prevStep) return
    const dir = next > this._prevStep ? 1 : -1
    this._prevStep = next
    animate(this.el, { opacity: [0, 1], x: [dir * 40, 0] }, OPTS)
  },
}
